import type { Enums } from "@msuite/utils/types";
import { boolean, enumeration, string, table } from "@rocicorp/zero";

export const ticketAssignmentReference = table("ticketAssignmentReferences")
	.from("ticket_assignment_references")
	.columns({
		id: string(),
		orgId: string().from("org_id"),
		crewId: string().from("crew_id"),
		projectId: string().from("project_id"),
		isInternalPlan: boolean().from("is_internal_plan"),
		isExternalPlan: boolean().from("is_external_plan"),
		calculationType: enumeration<Enums<"assignmentCalculationType">>().from("calculation_type"),
	})
	.primaryKey("id");
